const PreOrderSalesMethodModal = ({
  isOpen,
  onClose,
  storeData,
}: {
  isOpen: boolean;
  onClose: () => void;
  storeData: any;
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg">
        <h2 className="text-2xl font-extrabold mb-4">판매 방식 설명</h2>
        <div className="text-gray-600">
          <div className="mb-2 font-semibold">
            ✅ 팩 하나당{" "}
            {storeData?.getSellerStore?.pack?.price.toLocaleString()}원 이상
            담아주세요~!
          </div>
          <div className="text-md text-gray-500 mb-2">
            고객은 {storeData?.getSellerStore?.pack?.userPrice.toLocaleString()}
            원에 구매했습니다.
          </div>
          <div className="mb-2 font-semibold">
            ✅ [취소]상품이 없으면 손쉽게 취소하세요!
          </div>
          <div className="text-md text-gray-500 mb-2">
            고객들도 취소될 수 있다는 사실을 잘 인지하고 있답니다!
          </div>
          <div className="mb-2 font-semibold">
            ✅ [조기 확정] 조기확정 시 고객은 알림을 받고 지금 이 시점부터
            픽업이 가능해요!
          </div>
          <div className="mb-2 font-semibold">
            ✅ [자동 확정] 픽업시간 30분 전까지 확정/취소가 안되면 자동으로
            확정되어. 픽업시간에 손님이 도착해요!
          </div>
          <div className="mb-2 font-semibold">
            ✅ [내일 예약] 내일 픽업시간에 픽업을 하러오겠다는 주문이에요!. 내일
            픽업시간 시작 30분전까지 취소가 가능해요!
          </div>
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="mt-4 font-bold text-xl bg-blue-500 text-white px-4 py-2 rounded"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreOrderSalesMethodModal;
